// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const ChevronDownBigIcon = (props?: any) => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 16a1 1 0 01-.71-.29l-6-6a1 1 0 011.42-1.42l5.29 5.3 5.29-5.3a1 1 0 011.42 1.42l-6 6A1 1 0 0112 16z" fill="currentColor"/></svg>'} />;

(ChevronDownBigIcon as any).displayName = 'ChevronDownBigIcon';

export default ChevronDownBigIcon;
